import { render, staticRenderFns } from "./PaidColumn.vue?vue&type=template&id=f00b25ae"
import script from "./PaidColumn.vue?vue&type=script&lang=js"
export * from "./PaidColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports